<template>
  <div class="child-select">
    <br>
    <div class="row">
      <div class="col-12 d-flex justify-content-between">
        <div>
        <button v-on:click="setFilter(null)" :class="['btn me-1', filterBy === null ? 'btn-info' : 'btn-secondary']">Toon alle</button>
        <button v-on:click="setFilter('present')" :class="['btn me-1', filterBy === 'present' ? 'btn-info' : 'btn-secondary']">Nu aanwezig</button>
        <button v-on:click="setFilter('day-present')" :class="['btn me-1', filterBy === 'day-present' ? 'btn-info' : 'btn-secondary']">Vandaag aangemeld</button>
        </div>
        <div>
        <button v-if="selectedChildren.length < filter(children).length" v-on:click="selectAll()" class="btn btn-secondary">Selecteer alle</button>
        <button v-else v-on:click="deselectAll()" class="btn btn-secondary">Deselecteer alle</button>
        </div>
      </div>
      <div class="col-12 mt-2 text-end">
        {{ selectedChildren.length }} van {{ children.length }} geselecteerd
      </div>
      <div
          v-if="showFilter !== false"
          class="col-12"
      >
        <child-filter/>
        <br>
      </div>
      <div
          v-if="showSchoolFilter !== false && schools.length > 1"
          class="col-12"
      >
        <select v-model="filterBySchool" class="form-control">
          <option :value="null">Alle scholen</option>
          <option
            v-for="school in schools"
            v-bind:key="school.id"
            :value="school"
          >
            {{ school.name }}
          </option>
        </select>
      </div>
      <div class="col-12">
        <hr>
      </div>
      <div v-bind:key="child.id" v-for="child in sortChildren(filter(children))" style="margin-bottom: 4px;" class="col-12 col-sm-6">
        <div v-on:click="toggleSelect(child)" class="row">
          <div class="col-3">
            <child-thumbnail :key="child.id" :child="child" :type="'select'" :selected="isSelected(child)"></child-thumbnail>
          </div>
          <div class="col-9 d-flex flex-column">
            {{ child.full_name }}
            <span v-if="showDateOfBirth">
              {{ getAge(child.date_of_birth) }}
            </span>
            <icon
              v-if="showAllowPhoto && child.photo_allowed != 1"
              name="photos-none-solid"
              :fontSize="'1rem'"
            ></icon>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChildThumbnail from '@/components/Child-Thumbnail'
import ChildFilter from '@/components/Child-Filter'
import Icon from "@/components/Icon.vue";
export default {
  name: 'child-select',
  components: {
      Icon,
    ChildThumbnail,
    ChildFilter
  },
  props: ['all', 'initialSelected', 'orderBy', 'order', 'showDateOfBirth', 'showFilter', 'showSchoolFilter', 'showAllowPhoto'],
  data () {
    return {
      selectedChildren: [],
      filterBy: null,
      filterBySchool: null,
      schools: [],
      childrenSetOnce: false
    }
  },
  computed: {
    children () {
      if (this.all === true) {
        return this.getChildren(true)
      } else {
        return this.getChildren()
      }
    }
  },
  created () {
    this.setSchools()
    if (this.initialSelected) {
      for (var i = 0; i < this.initialSelected.length; i++) {
        var child = this.getChild(this.initialSelected[i])
        if (child) {
          this.selectedChildren.push(child)
        }
      }
    }
  },
  methods: {
    setCachedChildren (children) {
      this.cachedChildren = children
    },
    setChildrenSetOnce (bool) {
      this.childrenSetOnce = bool
    },
    setSchools () {
      var schoolIds = []
      var schools = []
      for (var i = 0; i < this.children.length; i++) {
        if (
          this.children[i].school !== null
          && this.children[i].school !== false
          && !schoolIds.includes(this.children[i].school.id)
        ) {
          schoolIds.push(this.children[i].school.id)
          schools.push(this.children[i].school)
        }
      }
      schools = this.$lodash().sortBy(schools, [school => school.name], 'asc')
      this.schools = schools
    },
    toggleSelect (child) {
      if (this.isSelected(child)) {
        var index = this.selectedChildren.indexOf(child)
        if (index > -1) {
          this.selectedChildren.splice(index, 1)
        }
      } else {
        this.selectedChildren.push(child)
      }
      this.$emit('onSelect', this.selectedChildren)
    },
    isSelected (child) {
      for (var i = 0; i < this.selectedChildren.length; i++) {
        if (this.selectedChildren[i].id === child.id) {
          return true
        }
      }
      return false
    },
    selectAll () {
      var selectedChildren = this.$lodash().clone(this.filter(this.children))
      this.selectedChildren = selectedChildren
      this.$emit('onSelect', selectedChildren)
    },
    deselectAll () {
      this.selectedChildren = []
      this.$emit('onSelect', [])
    },
    setFilter (filterBy) {
      this.filterBy = filterBy
    },
    filter (children) {
      if (!this.filterBy && this.filterBySchool === null) {
        return children
      }
      var app = this
      if (this.filterBySchool !== null) {
        var idSchool = this.filterBySchool.id
        children = this.$lodash().filter(children, function (child) {
          return child.school && child.school.id && child.school.id === idSchool
        })
      }
      if (this.filterBy === 'present') {
        children = this.$lodash().filter(children, function (child) {
          return app.getChildIsPresent(child) === true
        })
      }
      if (this.filterBy === 'day-present') {
        children = this.$lodash().filter(children, function (child) {
          return app.getChildIsPresentDay(child) === true
        })
      }
      return children
    }
  }
}
</script>

<style scoped>
  * {
      -webkit-user-select: none;
      -khtml-user-select: none;
      -moz-user-select: none;
      -o-user-select: none;
      user-select: none;
      cursor: pointer;
  }
</style>
